define('models/ContactCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'ApiRequest', 'app', 'models/ContactModel'],

    function (_, ObjectCollection, LocalStorage, ApiRequest, app, ContactModel) {
    //
    // Model Gender
    //
    var ContactCollectionPrototype = {

        name: 'ContactCollection',
        route: 'apiContactCollection',
        model:ContactModel,
        initialize: function () {
            // ObjectModel constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
            //
        },


    };

    var ContactCollection = ObjectCollection.extend(LocalStorage).extend(ContactCollectionPrototype);

    return ContactCollection;
});
